import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/surveys/selectors";
import { updateSurveyAsync } from "redux-toolkit/surveys/actions";

const useUpdateSurvey = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const updateSurvey = useCallback(
    (id, data) => {
      dispatch(updateSurveyAsync({ id, data }));
    },
    [dispatch],
  );

  return {
    isLoading,
    updateSurvey,
  };
};

export default useUpdateSurvey;
